export const ds_AccordionLayoutBlock_Entry = `
    fragment ds_AccordionLayoutBlock_Entry on ds_AccordionLayoutBlock_Entry {
        id
        canonicalUid
        accordion_ColorTheme
        accordion_ColorPalette
        accordion_AccordionStyle
        accordion_ContentAlignment
        accordion_Padding
        accordion_AccordionItems {
            ... on ds_AccordionItem_Entry {
                id
                accordionItem_Heading
                accordionItem_BodyContent
                accordionItem_Icon {
                    type
                    set
                    name
                }
            }
        }
    }
`
